<div class="row mb-4 p-2">
    <div class="col-12 mt-2 p-0 mb-4" *ngIf="searchResult">
        <ng-container *ngIf="showNoContent && searchInput.length > 0">
        </ng-container>
    </div>

    <!-- Invite/Create Beneficiary Details-->
    <div class="col-12 mt-3 p-0">
        <h6 class="mb-2">Enter the details of <b>maximum 3 Beneficiaries</b> who will be using the Imagility during free trial.
        </h6>
        <div class="col-sm-12 mt-2 mb-3 p-0">
            <!--Send Invite-->
            <ng-container *ngIf="!createNewBeneficiaryFlag">
                <form [formGroup]="inviteExternalBeneForm" #inviteBene="ngForm"
                    (ngSubmit)="inviteExternalBeneFormSub()">
                    <div class="form-row">
                        <div class="form-group col-md-4 pr-5">
                            <div class="p-field">
                                <label class="required" for="firstName">First Name</label>
                                <input [disabled]="disableFields" id="firstName" type="text" pInputText formControlName="firstName"
                                    [ngClass]="{ 'im-input-error': (f1.firstName.touched || isSubmitted) && f1.firstName.errors  }" />
                            </div>
                        </div>
                        <div class="form-group col-md-4 pr-5">
                            <div class="p-field">
                                <label class="required" for="lastName">Last Name</label>
                                <input [disabled]="disableFields" id="lastName" type="text" pInputText formControlName="lastName"
                                    [ngClass]="{ 'im-input-error': (f1.lastName.touched || isSubmitted) && f1.lastName.errors  }" />
                            </div>
                        </div>
                        <div class="form-group col-md-4">
                            <div class="p-field">
                                <label for="middleName">Middle Name<small> (Optional)</small></label>
                                <input [disabled]="disableFields" id="middleName" type="text" pInputText formControlName="middleName" />
                            </div>
                        </div>
                        <div class="form-group col-md-4 pr-5">
                            <div class="p-field">
                                <label class="required" for="userId">Username / ID</label>
                                <input [disabled]="disableFields" id="userId" minlength="5" maxlength="12" pattern="[a-zA-Z0-9][a-zA-Z0-9\s]*"
                                (keypress)="keyPressAlphaNumericWithCharacters($event)" type="text" pInputText formControlName="userId"
                                    [ngClass]="{ 'im-input-error': (f1.userId.touched || isSubmitted) && f1.userId.errors  }" />
                            </div>
                        </div>
                        <div class="form-group col-md-4 pr-5">
                            <div class="p-field">
                                <label class="required" for="communicationEmailId">Communication Email Id</label>
                                <input [disabled]="disableFields" id="communicationEmailId" type="text" pInputText pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$"
                                    formControlName="communicationEmailId"
                                    [ngClass]="{ 'im-input-error': (f1.communicationEmailId.touched || isSubmitted) && f1.communicationEmailId.errors  }" />
                            </div>
                        </div>
                    </div>
                    <button *ngIf="this.orgeditBtnInviteBene" type="submit" class="im-btn im-btn-primary im-btn-md p-2"
                        [disabled]="inviteExternalBeneForm.invalid || inviteExternalBeneForm.disabled">
                        <i class="fa fa-plus-circle"></i> Add to Invite List
                    </button>
                    <button *ngIf="this.editBtnInviteBene" type="button" (click)="updateInvitelist()" class="im-btn im-btn-primary im-btn-md p-2">
                        <i class="fa fa-plus-circle"></i> Add to Invite List
                     </button><br><br>
                    <span class="invite-info pt-2"><i class="fa fa-info-circle"></i> 
                        Invitations will be sent only after you finish all the step.</span>
                </form>
            </ng-container>

            <p-dialog header="Invite Beneficiaries" [(visible)]="displayBasic" [style]="{width: '25vw'}">
                <p>You can invite upto Maximum 3 Beneficiaries </p>
            </p-dialog>

            <!--EOD Send Invite-->
            
            <!-- Create Beneficiary-->
            <ng-container *ngIf="createNewBeneficiaryFlag">
                <form [formGroup]="createNewBene" #inviteBene="ngForm" (ngSubmit)="createBeneFormSub()">
                    <div class="p-fluid p-formgrid p-grid">
                        <div class="p-field p-col mr-3 pr-3">
                            <label class="required" for="firstName">First Name</label>
                            <input [disabled]="disableFields" id="firstName" type="text" pInputText formControlName="firstName"
                                [ngClass]="{ 'im-input-error': (f.firstName.touched || isSubmitted) && f.firstName.errors  }" />
                        </div>
                        <div class="required" class="p-field p-col mr-3 pr-3">
                            <label class="required" for="lastName">Last Name</label>
                            <input [disabled]="disableFields" id="lastName" type="text" pInputText formControlName="lastName"
                                [ngClass]="{ 'im-input-error': (f.lastName.touched || isSubmitted) && f.lastName.errors  }" />
                        </div>
                        <div class="p-field p-col">
                            <label for="middleName">Middle Name<small> (Optional)</small></label>
                            <input [disabled]="disableFields" id="middleName" type="text" pInputText formControlName="middleName" />
                        </div>
                    </div>

                    <div class="p-fluid p-formgrid p-grid">
                        <div class="p-field p-col mr-3 pr-3">
                            <label class="required" for="firstName">Gender</label>
                            <p-dropdown [disabled]="disableFields" placeholder="Select" [options]="gender" optionValue="value" formControlName="genderType" >
                            </p-dropdown>
                        </div>
                        <div class="p-field p-col mr-3 pr-3">
                            <label class="required" for="date">Date of Birth</label>
                            <input [disabled]="disableFields" id="date" type="date" pInputDate formControlName="date"
                                [ngClass]="{ 'im-input-error': (f.date.touched || isSubmitted) && f.date.errors  }" />
                        </div>
                        <div class="p-field p-col">
                            <label for="emailId">Communication Email ID<small> (Optional)</small></label>
                            <input [disabled]="disableFields" id="emailId" type="text" pInputText formControlName="emailId"
                                [ngClass]="{ 'im-input-error': (f.emailId.touched || isSubmitted) && f.emailId.errors  }" />
                        </div>
                    </div>

                    <div class="p-fluid p-formgrid p-grid mt-3">
                        <span class="required" class="pl-1">What is the immigration type Beneficiary is applying
                            for?</span>
                        <div class="p-field-radiobutton pr-3 d-block mt-2">
                            <p-radioButton [disabled]="true" class="pr-3" *ngFor="let item of familyType" name="immType"
                                formControlName="immType" [value]="item.code" [label]="item.name" [inputId]="item.id">
                            </p-radioButton>
                        </div>
                    </div>

                    <div class="p-fluid p-formgrid p-grid">
                        <div class="p-field p-col-4 p-0 mr-5 pr-4">
                            <label class="required" for="firstName">Beneficiary Type</label>
                            <p-dropdown [disabled]="disableFields" placeholder="Select" optionLabel="name" [options]="taskType" optionValue="code"
                                formControlName="benType">
                            </p-dropdown>
                        </div>
                        <div class="p-field p-formgroup-inline p-col-7">
                            <span class="pb-2">Beneficiary currently living in the U.S.?</span>
                            <div class="p-field-radiobutton">
                                <p-radioButton [disabled]="disableFields" (click)="benLivingUSCheck(1)" name="benLivingUS" value="1"
                                    formControlName="benLivingUS" inputId="ben-livingUS1">
                                </p-radioButton>
                                <label for="ben-livingUS1">Yes</label>
                            </div>
                            <div class="p-field-radiobutton pl-3">
                                <p-radioButton [disabled]="disableFields" (click)="benLivingUSCheck(0)" name="benLivingUS" value="0"
                                    formControlName="benLivingUS" inputId="ben-livingU2">
                                </p-radioButton>
                                <label for="ben-livingUS2">No</label>
                            </div>
                        </div>
                    </div>
                    <ng-container *ngIf="residingUs">
                        <div class="p-fluid p-formgrid p-grid">
                            <span>On which visa did Beneficiary enter U.S.?</span>
                            <div class="p-field p-col-4 p-0 mr-5 pr-4">
                                <label class="required" for="benType" class="pb-2">Visa Type</label>
                                <p-dropdown [disabled]="disableFields" inputId="benType" [options]="visaTypes" formControlName="selectedBenType" optionValue="code"
                                    placeholder="Select" optionLabel="name"></p-dropdown>
                            </div>
                        </div>
                        <div class="p-fluid p-formgrid p-grid">
                            <div class="p-field p-formgroup-inline p-col p-0">
                                <span style="display: block;width: 100%;">Has Beneficiary maintained immigration
                                    status?</span>
                                <div class="p-field-radiobutton">
                                    <p-radioButton [disabled]="disableFields" name="hasImmigration" value="1" formControlName="hasImmigration"
                                        inputId="ben-livingUS1">
                                    </p-radioButton>
                                    <label for="ben-livingUS1">Yes</label>
                                </div>
                                <div class="p-field-radiobutton pl-3">
                                    <p-radioButton [disabled]="disableFields" name="hasImmigration" value="0" formControlName="hasImmigration"
                                        inputId="ben-livingU2">
                                    </p-radioButton>
                                    <label for="ben-livingUS2">No</label>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <button pButton *ngIf="!isUpdateBene" pRipple type="submit" label="Create New" icon="pi pi-plus"
                        [disabled]="createNewBene.invalid || disableFields"></button>
                    <button pButton *ngIf="isUpdateBene" pRipple type="submit" label="Update" icon="pi pi-plus"
                    [disabled]="createNewBene.invalid || disableFields"></button>

                   

                </form>
            </ng-container>
            <!--EOD Create Beneficiary-->
        </div>
        <!--EOD Choose Invite/Create Beneficiary-->
    </div>
    <!--EOD Beneficiary Details-->

    <span class="dashed-divider"></span>

    <!--Invite Sent Beneficiary Details-->
    <div class="col-sm-12 mt-3 mb-5 p-0">
        <span class="mb-1"><h6>Invite Sent Beneficiary Details</h6></span>
        <p-table [responsive]="true" [value]="inviteSent">
            <ng-template pTemplate="header">
                <tr>
                    <th>Name</th>
                    <th>User ID</th>
                    <th>Communication Email</th>
                    <th>Actions</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-inviteSent let-i="rowIndex">
                <tr>
                    <td>{{inviteSent.firstName + ' ' + inviteSent.lastName}}</td>
                    <td>{{inviteSent.userId }}</td>
                    <td>{{inviteSent.emailId}}</td>
                    <td>
                        <div class="ml-2">
                            <span class="ml-2 mr-2"><mat-icon class="mr-1 icn"
                              matTooltip="Edit" (click)="editNewsendinvite(inviteSent, i)"
                              class="material-icons">edit</mat-icon></span>
                            <span  (click)="deleteImmigration(inviteSent)">
                              <mat-icon
                                class="mr-1 icn"
                                matTooltip="Delete User"
                                class="material-icons">delete</mat-icon>
                            </span>                            
                          </div>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-inviteSent>
                <tr>
                    <td [attr.colspan]="4">
                        No records found
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <!--EOD Invite Sent Beneficiary Details-->
</div>

<div class="row">
    <div class="col-6"></div>
    <div class="col text-right">
      <button (click)="onCancel()" pButton type="button" class="align-top mr-4 p-button-secondary">
        Cancel
      </button>
      <div class="border-right d-inline-block mr-4" style="height:46px"></div>
      <button (click)="onPrevious()" class="im-btn im-btn-primary im-btn-md mr-2" [disabled]="">
        Previous
      </button>
      <button (click)="onNext()" class="im-btn im-btn-primary im-btn-md"> Next </button>
    </div>
</div>
  <p-confirmDialog header="Delete"></p-confirmDialog>